import './recruit.svelte.css.proxy.js';
/* src/routes/recruit.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	query_selector_all,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../../_snowpack/pkg/svelte/internal.js";

import Nav from "../../_components/navigation/Nav.svelte.js";
import Wrap from "../../_components/slot/Wrap.svelte.js";
import Inner from "../../_components/slot/Inner.svelte.js";
import Section from "../../_components/slot/Section.svelte.js";
import Columns from "../../_components/column/Columns.svelte.js";
import Column from "../../_components/column/Column.svelte.js";
import MainVisual from "../../_components/recruit/MainVisual.svelte.js";
import Breadcrumb from "../../_components/block/Breadcrumb.svelte.js";
import Title from "../../_components/block/Title.svelte.js";
import Heading from "../../_components/block/Heading.svelte.js";
import Hr from "../../_components/element/Hr.svelte.js";
import Item from "../../_components/slot/Item.svelte.js";
import Table from "../../_components/element/Table.svelte.js";
import Button from "../../_components/button/Button.svelte.js";
import Flow from "../../_components/recruit/Flow.svelte.js";
import Points from "../../_components/recruit/Points.svelte.js";

function create_default_slot_73(ctx) {
	let mainvisual;
	let current;
	mainvisual = new MainVisual({});

	return {
		c() {
			create_component(mainvisual.$$.fragment);
		},
		l(nodes) {
			claim_component(mainvisual.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(mainvisual, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(mainvisual.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(mainvisual.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(mainvisual, detaching);
		}
	};
}

// (36:0) <Section kind="gapless">
function create_default_slot_72(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_73] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (43:2) <Wrap fullOnMobile>
function create_default_slot_71(ctx) {
	let breadcrumb;
	let t;
	let title;
	let current;
	breadcrumb = new Breadcrumb({ props: { paths: /*paths*/ ctx[0] } });

	title = new Title({
			props: { name: "採用情報", en: "Recruit information" }
		});

	return {
		c() {
			create_component(breadcrumb.$$.fragment);
			t = space();
			create_component(title.$$.fragment);
		},
		l(nodes) {
			claim_component(breadcrumb.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(title.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(breadcrumb, target, anchor);
			insert(target, t, anchor);
			mount_component(title, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(breadcrumb.$$.fragment, local);
			transition_in(title.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(breadcrumb.$$.fragment, local);
			transition_out(title.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(breadcrumb, detaching);
			if (detaching) detach(t);
			destroy_component(title, detaching);
		}
	};
}

// (42:0) <Section kind="top-small">
function create_default_slot_70(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				fullOnMobile: true,
				$$slots: { default: [create_default_slot_71] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (51:4) <Inner>
function create_default_slot_69(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("自動車業界はいま、社会の少子化や新しい技術の登場で、大きな変革期にあります。そうした状況にあって当社は、電気や通信といったインフラに欠かせない高所作業車の整備で大手企業のお客様から厚い信頼をいただくなど、安定成長を続けています。整備士の採用・育成に積極的に取り組んでいるのも、そのためです。求める人材としては、向上心があれば未経験者も大歓迎！実際、全くの未経験で入社し、国家資格の取得を目指している先輩も活躍しています。あなたも当社で、自動車整備のプロを目指してみませんか。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "自動車業界はいま、社会の少子化や新しい技術の登場で、大きな変革期にあります。そうした状況にあって当社は、電気や通信といったインフラに欠かせない高所作業車の整備で大手企業のお客様から厚い信頼をいただくなど、安定成長を続けています。整備士の採用・育成に積極的に取り組んでいるのも、そのためです。求める人材としては、向上心があれば未経験者も大歓迎！実際、全くの未経験で入社し、国家資格の取得を目指している先輩も活躍しています。あなたも当社で、自動車整備のプロを目指してみませんか。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (50:2) <Wrap>
function create_default_slot_68(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_69] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (49:0) <Section kind="top-small">
function create_default_slot_67(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_68] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (62:6) <Item align="center">
function create_default_slot_66(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				name: "応募される方のお問い合わせフォームはこちら",
				href: "/contact?kind=recruit"
			}
		});

	return {
		c() {
			create_component(button.$$.fragment);
		},
		l(nodes) {
			claim_component(button.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (61:4) <Inner>
function create_default_slot_65(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				align: "center",
				$$slots: { default: [create_default_slot_66] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (60:2) <Wrap>
function create_default_slot_64(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_65] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (59:0) <Section kind="small">
function create_default_slot_63(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_64] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (70:2) <Inner>
function create_default_slot_62(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (69:0) <Wrap>
function create_default_slot_61(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_62] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (84:6) <Item>
function create_default_slot_60(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("当社の大きな特徴は、多種多様な自動車の車検整備ができる分解整備認定工場になっていることです。このため、整備士として様々なスキルを身に着けることができます。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "当社の大きな特徴は、多種多様な自動車の車検整備ができる分解整備認定工場になっていることです。このため、整備士として様々なスキルを身に着けることができます。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (88:6) <Item>
function create_default_slot_59(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);

			img = claim_element(figure_nodes, "IMG", {
				src: true,
				srcset: true,
				alt: true,
				class: true
			});

			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/recruit-01.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/recruit-01-SP.jpg 768w, /images/recruit-01.jpg");
			attr(img, "alt", "軽から普通、さらには大型・特殊まで多種多様な自動車の整備ができます");
			attr(img, "class", "svelte-gfev66");
			attr(figure, "class", "svelte-gfev66");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (77:4) <Inner>
function create_default_slot_58(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;

	heading = new Heading({
			props: {
				name: "軽から普通、さらには大型・特殊まで多種多様な自動車の整備ができます。",
				image: "/images/recruit.png",
				color: "orange"
			}
		});

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_60] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_59] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (76:2) <Wrap>
function create_default_slot_57(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_58] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (75:0) <Section kind="small">
function create_default_slot_56(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_57] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (102:2) <Inner>
function create_default_slot_55(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (101:0) <Wrap>
function create_default_slot_54(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_55] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (116:6) <Item>
function create_default_slot_53(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("当社の社員に共通しているのは、クルマ好きが集まっていること。そこに年齢や性別は、一切関係ありません。誰もが楽しくノビノビと仕事ができる環境になっています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "当社の社員に共通しているのは、クルマ好きが集まっていること。そこに年齢や性別は、一切関係ありません。誰もが楽しくノビノビと仕事ができる環境になっています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (120:6) <Item>
function create_default_slot_52(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);

			img = claim_element(figure_nodes, "IMG", {
				src: true,
				srcset: true,
				alt: true,
				class: true
			});

			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/recruit-02.jpg")) attr(img, "src", img_src_value);
			attr(img, "srcset", "/images/recruit-02-SP.jpg 768w, /images/recruit-02.jpg");
			attr(img, "alt", "年齢や性別等に関係なく楽しくノビノビと働ける職場環境になっています。");
			attr(img, "class", "svelte-gfev66");
			attr(figure, "class", "svelte-gfev66");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (109:4) <Inner>
function create_default_slot_51(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;

	heading = new Heading({
			props: {
				name: "年齢や性別等に関係なく楽しくノビノビと働ける職場環境になっています。",
				image: "/images/recruit.png",
				color: "orange"
			}
		});

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_53] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_52] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (108:2) <Wrap>
function create_default_slot_50(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_51] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (107:0) <Section kind="small">
function create_default_slot_49(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_50] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (134:2) <Inner>
function create_default_slot_48(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (133:0) <Wrap>
function create_default_slot_47(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_48] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (148:6) <Item>
function create_default_slot_46(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("電気や通信といったインフラ整備で活躍する高所作業車の整備が全体の80%を占めており、安定した経営を維持しています。新型コロナウイルスによる経済の影響をほとん受けないので、安心して働くことが出来ます。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "電気や通信といったインフラ整備で活躍する高所作業車の整備が全体の80%を占めており、安定した経営を維持しています。新型コロナウイルスによる経済の影響をほとん受けないので、安心して働くことが出来ます。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (154:10) <Column columns="2">
function create_default_slot_45(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true, class: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/data.png")) attr(img, "src", img_src_value);
			attr(img, "alt", "インフラ整備で活躍する車両整備を中心に安定した経営基盤を築いています");
			attr(img, "class", "svelte-gfev66");
			attr(figure, "class", "svelte-gfev66");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (162:10) <Column columns="2">
function create_default_slot_44(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true, class: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/moji.png")) attr(img, "src", img_src_value);
			attr(img, "alt", "経営が安定している優良企業だから自分らしく豊かな未来が描けます");
			attr(img, "class", "svelte-gfev66");
			attr(figure, "class", "svelte-gfev66");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (153:8) <Columns>
function create_default_slot_43(ctx) {
	let column0;
	let t;
	let column1;
	let current;

	column0 = new Column({
			props: {
				columns: "2",
				$$slots: { default: [create_default_slot_45] },
				$$scope: { ctx }
			}
		});

	column1 = new Column({
			props: {
				columns: "2",
				$$slots: { default: [create_default_slot_44] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(column0.$$.fragment);
			t = space();
			create_component(column1.$$.fragment);
		},
		l(nodes) {
			claim_component(column0.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(column1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(column0, target, anchor);
			insert(target, t, anchor);
			mount_component(column1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const column0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				column0_changes.$$scope = { dirty, ctx };
			}

			column0.$set(column0_changes);
			const column1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				column1_changes.$$scope = { dirty, ctx };
			}

			column1.$set(column1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(column0.$$.fragment, local);
			transition_in(column1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(column0.$$.fragment, local);
			transition_out(column1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(column0, detaching);
			if (detaching) detach(t);
			destroy_component(column1, detaching);
		}
	};
}

// (152:6) <Item>
function create_default_slot_42(ctx) {
	let columns;
	let current;

	columns = new Columns({
			props: {
				$$slots: { default: [create_default_slot_43] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(columns.$$.fragment);
		},
		l(nodes) {
			claim_component(columns.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(columns, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const columns_changes = {};

			if (dirty & /*$$scope*/ 2) {
				columns_changes.$$scope = { dirty, ctx };
			}

			columns.$set(columns_changes);
		},
		i(local) {
			if (current) return;
			transition_in(columns.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(columns.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(columns, detaching);
		}
	};
}

// (141:4) <Inner>
function create_default_slot_41(ctx) {
	let heading;
	let t0;
	let item0;
	let t1;
	let item1;
	let current;

	heading = new Heading({
			props: {
				name: "インフラ整備で活躍する車両整備を中心に安定した経営基盤を築いています。",
				image: "/images/recruit.png",
				color: "orange"
			}
		});

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_46] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_42] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t0 = space();
			create_component(item0.$$.fragment);
			t1 = space();
			create_component(item1.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item0.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t0, anchor);
			mount_component(item0, target, anchor);
			insert(target, t1, anchor);
			mount_component(item1, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t0);
			destroy_component(item0, detaching);
			if (detaching) detach(t1);
			destroy_component(item1, detaching);
		}
	};
}

// (140:2) <Wrap>
function create_default_slot_40(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_41] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (139:0) <Section kind="small">
function create_default_slot_39(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_40] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (177:2) <Inner>
function create_default_slot_38(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (176:0) <Wrap>
function create_default_slot_37(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_38] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (185:6) <Item>
function create_default_slot_36(ctx) {
	let figure;
	let img;
	let img_src_value;

	return {
		c() {
			figure = element("figure");
			img = element("img");
			this.h();
		},
		l(nodes) {
			figure = claim_element(nodes, "FIGURE", { class: true });
			var figure_nodes = children(figure);
			img = claim_element(figure_nodes, "IMG", { src: true, alt: true, class: true });
			figure_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (img.src !== (img_src_value = "/images/recruit-03.jpg")) attr(img, "src", img_src_value);
			attr(img, "alt", "インフラ整備で活躍する車両整備を中心に安定した経営基盤を築いています");
			attr(img, "class", "svelte-gfev66");
			attr(figure, "class", "svelte-gfev66");
		},
		m(target, anchor) {
			insert(target, figure, anchor);
			append(figure, img);
		},
		d(detaching) {
			if (detaching) detach(figure);
		}
	};
}

// (194:6) <Item>
function create_default_slot_35(ctx) {
	let heading;
	let current;

	heading = new Heading({
			props: {
				name: "ここで活躍する仲間からのメッセージ",
				image: "/images/recruit.png",
				color: "orange"
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
		}
	};
}

// (202:6) <Item>
function create_default_slot_34(ctx) {
	let p;
	let t;

	return {
		c() {
			p = element("p");
			t = text("小さい頃からクルマが好きで、自動車整備の仕事がしたかったのですが、その知識や経験がないため、なかなかチャンスがありませんでした。そんなとき、未経験でもチャレンジできる当社の存在を知ったのです。実際に入社してみると、やる気しだいでクルマのことをイチから覚えられる環境があって、わからないことも先輩の整備士に気兼ねなく聞くことができました。おかげで、毎日楽しく整備の仕事に取り組んでいます。クルマって、車種によってエ ンジン音に違いがあることを初めて知りました。目標としては、このまま働きながら自動車整備士の資格を取り、1人前になること。会社のバックアップがあるので、近い将来、実現できると思っています。");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t = claim_text(p_nodes, "小さい頃からクルマが好きで、自動車整備の仕事がしたかったのですが、その知識や経験がないため、なかなかチャンスがありませんでした。そんなとき、未経験でもチャレンジできる当社の存在を知ったのです。実際に入社してみると、やる気しだいでクルマのことをイチから覚えられる環境があって、わからないことも先輩の整備士に気兼ねなく聞くことができました。おかげで、毎日楽しく整備の仕事に取り組んでいます。クルマって、車種によってエ ンジン音に違いがあることを初めて知りました。目標としては、このまま働きながら自動車整備士の資格を取り、1人前になること。会社のバックアップがあるので、近い将来、実現できると思っています。");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (206:6) <Item>
function create_default_slot_33(ctx) {
	let div;
	let p0;
	let t0;
	let span;
	let t1;
	let t2;
	let p1;
	let t3;

	return {
		c() {
			div = element("div");
			p0 = element("p");
			t0 = text("河合政樹\n            ");
			span = element("span");
			t1 = text("君");
			t2 = space();
			p1 = element("p");
			t3 = text("（2020年入社 整備職）");
			this.h();
		},
		l(nodes) {
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);
			p0 = claim_element(div_nodes, "P", { class: true });
			var p0_nodes = children(p0);
			t0 = claim_text(p0_nodes, "河合政樹\n            ");
			span = claim_element(p0_nodes, "SPAN", { class: true });
			var span_nodes = children(span);
			t1 = claim_text(span_nodes, "君");
			span_nodes.forEach(detach);
			p0_nodes.forEach(detach);
			t2 = claim_space(div_nodes);
			p1 = claim_element(div_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t3 = claim_text(p1_nodes, "（2020年入社 整備職）");
			p1_nodes.forEach(detach);
			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(span, "class", "svelte-gfev66");
			attr(p0, "class", "name svelte-gfev66");
			attr(p1, "class", "details svelte-gfev66");
			attr(div, "class", "profile svelte-gfev66");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, p0);
			append(p0, t0);
			append(p0, span);
			append(span, t1);
			append(div, t2);
			append(div, p1);
			append(p1, t3);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (184:4) <Inner>
function create_default_slot_32(ctx) {
	let item0;
	let t0;
	let item1;
	let t1;
	let item2;
	let t2;
	let item3;
	let current;

	item0 = new Item({
			props: {
				$$slots: { default: [create_default_slot_36] },
				$$scope: { ctx }
			}
		});

	item1 = new Item({
			props: {
				$$slots: { default: [create_default_slot_35] },
				$$scope: { ctx }
			}
		});

	item2 = new Item({
			props: {
				$$slots: { default: [create_default_slot_34] },
				$$scope: { ctx }
			}
		});

	item3 = new Item({
			props: {
				$$slots: { default: [create_default_slot_33] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item0.$$.fragment);
			t0 = space();
			create_component(item1.$$.fragment);
			t1 = space();
			create_component(item2.$$.fragment);
			t2 = space();
			create_component(item3.$$.fragment);
		},
		l(nodes) {
			claim_component(item0.$$.fragment, nodes);
			t0 = claim_space(nodes);
			claim_component(item1.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(item2.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(item3.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item0, target, anchor);
			insert(target, t0, anchor);
			mount_component(item1, target, anchor);
			insert(target, t1, anchor);
			mount_component(item2, target, anchor);
			insert(target, t2, anchor);
			mount_component(item3, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item0_changes.$$scope = { dirty, ctx };
			}

			item0.$set(item0_changes);
			const item1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item1_changes.$$scope = { dirty, ctx };
			}

			item1.$set(item1_changes);
			const item2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item2_changes.$$scope = { dirty, ctx };
			}

			item2.$set(item2_changes);
			const item3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item3_changes.$$scope = { dirty, ctx };
			}

			item3.$set(item3_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item0.$$.fragment, local);
			transition_in(item1.$$.fragment, local);
			transition_in(item2.$$.fragment, local);
			transition_in(item3.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item0.$$.fragment, local);
			transition_out(item1.$$.fragment, local);
			transition_out(item2.$$.fragment, local);
			transition_out(item3.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item0, detaching);
			if (detaching) detach(t0);
			destroy_component(item1, detaching);
			if (detaching) detach(t1);
			destroy_component(item2, detaching);
			if (detaching) detach(t2);
			destroy_component(item3, detaching);
		}
	};
}

// (183:2) <Wrap>
function create_default_slot_31(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_32] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (182:0) <Section kind="small">
function create_default_slot_30(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_31] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (221:2) <Inner>
function create_default_slot_29(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (220:0) <Wrap>
function create_default_slot_28(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_29] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (235:6) <Item>
function create_default_slot_27(ctx) {
	let flow;
	let current;
	flow = new Flow({});

	return {
		c() {
			create_component(flow.$$.fragment);
		},
		l(nodes) {
			claim_component(flow.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(flow, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(flow.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(flow.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(flow, detaching);
		}
	};
}

// (228:4) <Inner>
function create_default_slot_26(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "応募から採用までの流れ",
				image: "/images/recruit.png",
				color: "orange"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_27] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (227:2) <Wrap>
function create_default_slot_25(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_26] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (226:0) <Section kind="top-small">
function create_default_slot_24(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_25] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (245:6) <Item align="center">
function create_default_slot_23(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				name: "応募される方のお問い合わせフォームはこちら",
				href: "/contact?kind=recruit"
			}
		});

	return {
		c() {
			create_component(button.$$.fragment);
		},
		l(nodes) {
			claim_component(button.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (244:4) <Inner>
function create_default_slot_22(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				align: "center",
				$$slots: { default: [create_default_slot_23] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (243:2) <Wrap>
function create_default_slot_21(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_22] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (242:0) <Section kind="top-small">
function create_default_slot_20(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_21] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (254:4) <Inner>
function create_default_slot_19(ctx) {
	let points;
	let current;
	points = new Points({});

	return {
		c() {
			create_component(points.$$.fragment);
		},
		l(nodes) {
			claim_component(points.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(points, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(points.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(points.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(points, detaching);
		}
	};
}

// (253:2) <Wrap>
function create_default_slot_18(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_19] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (252:0) <Section kind="small">
function create_default_slot_17(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_18] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (261:2) <Inner>
function create_default_slot_16(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (260:0) <Wrap>
function create_default_slot_15(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_16] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (276:8) <Table>
function create_default_slot_14(ctx) {
	let tr0;
	let th0;
	let t0;
	let t1;
	let td0;
	let t2;
	let t3;
	let tr1;
	let th1;
	let t4;
	let t5;
	let td1;
	let t6;
	let t7;
	let tr2;
	let th2;
	let t8;
	let t9;
	let td2;
	let p0;
	let t10;
	let t11;
	let p1;
	let t12;
	let t13;
	let tr3;
	let th3;
	let t14;
	let t15;
	let td3;
	let t16;
	let br0;
	let t17;
	let t18;
	let tr4;
	let th4;
	let t19;
	let t20;
	let td4;
	let t21;
	let t22;
	let tr5;
	let th5;
	let t23;
	let t24;
	let td5;
	let t25;
	let br1;
	let t26;
	let t27;
	let tr6;
	let th6;
	let t28;
	let t29;
	let td6;
	let t30;
	let br2;
	let t31;
	let t32;
	let tr7;
	let th7;
	let t33;
	let t34;
	let td7;
	let t35;
	let t36;
	let tr8;
	let th8;
	let t37;
	let t38;
	let td8;
	let t39;
	let t40;
	let tr9;
	let th9;
	let t41;
	let t42;
	let td9;
	let t43;
	let t44;
	let tr10;
	let th10;
	let t45;
	let t46;
	let td10;
	let t47;
	let t48;
	let tr11;
	let th11;
	let t49;
	let t50;
	let td11;
	let t51;
	let t52;
	let tr12;
	let th12;
	let t53;
	let t54;
	let td12;
	let p2;
	let t55;
	let t56;
	let p3;
	let t57;

	return {
		c() {
			tr0 = element("tr");
			th0 = element("th");
			t0 = text("募集職種");
			t1 = space();
			td0 = element("td");
			t2 = text("自動車整備士");
			t3 = space();
			tr1 = element("tr");
			th1 = element("th");
			t4 = text("雇用形態");
			t5 = space();
			td1 = element("td");
			t6 = text("正社員");
			t7 = space();
			tr2 = element("tr");
			th2 = element("th");
			t8 = text("仕事内容");
			t9 = space();
			td2 = element("td");
			p0 = element("p");
			t10 = text("一般自動車から特装車まで幅広い車種の自動車整備、車検、定期点検業務");
			t11 = space();
			p1 = element("p");
			t12 = text("エンジンオイル、オートマチックオイル、冷却水、タイヤ交換などの整備をはじめ、お客様のお車の使用頻度や状況に合わ せた部品交換や修理などのメンテナンス含め、幅広くサポートをお願いします。");
			t13 = space();
			tr3 = element("tr");
			th3 = element("th");
			t14 = text("勤務地");
			t15 = space();
			td3 = element("td");
			t16 = text("本社工場／群馬県前橋市三俣町2-1-3");
			br0 = element("br");
			t17 = text("\n              芳賀特装工場／群馬県前橋市鳥取町646-3");
			t18 = space();
			tr4 = element("tr");
			th4 = element("th");
			t19 = text("勤務時間");
			t20 = space();
			td4 = element("td");
			t21 = text("8:30~17:30（休憩60分） ※時間外有り、月平均15時間程度");
			t22 = space();
			tr5 = element("tr");
			th5 = element("th");
			t23 = text("休日・休暇");
			t24 = space();
			td5 = element("td");
			t25 = text("土曜、日曜、祝日、夏季、年末年始");
			br1 = element("br");
			t26 = text("※土曜出勤応相談 有給休暇、結婚休暇、産休・育休制度有り");
			t27 = space();
			tr6 = element("tr");
			th6 = element("th");
			t28 = text("給与");
			t29 = space();
			td6 = element("td");
			t30 = text("月給180,000~350,000円");
			br2 = element("br");
			t31 = text("※経験・スキルにより決定します");
			t32 = space();
			tr7 = element("tr");
			th7 = element("th");
			t33 = text("諸手当");
			t34 = space();
			td7 = element("td");
			t35 = text("残業手当、休日出勤手当、資格手当、役職手当");
			t36 = space();
			tr8 = element("tr");
			th8 = element("th");
			t37 = text("昇給");
			t38 = space();
			td8 = element("td");
			t39 = text("年1回（4月）※業績に応じて");
			t40 = space();
			tr9 = element("tr");
			th9 = element("th");
			t41 = text("賞与");
			t42 = space();
			td9 = element("td");
			t43 = text("年2回（業績に応じて支給）");
			t44 = space();
			tr10 = element("tr");
			th10 = element("th");
			t45 = text("福利厚生");
			t46 = space();
			td10 = element("td");
			t47 = text("社会保険完備（健康保険・厚生年金保険・雇用保険・労災保険）、健康診断、マイカー・バイク・自転車通勤可、制服貸与、資格取得支援制度（規定有り）、再雇用制度、食事スペース・休憩スペース有り");
			t48 = space();
			tr11 = element("tr");
			th11 = element("th");
			t49 = text("資格・経験");
			t50 = space();
			td11 = element("td");
			t51 = text("自動車整備士＜経験者優遇＞普通自動車免許（AT限定不可）");
			t52 = space();
			tr12 = element("tr");
			th12 = element("th");
			t53 = text("学歴・年齢");
			t54 = space();
			td12 = element("td");
			p2 = element("p");
			t55 = text("高卒以上、男女問わず幅広い年齢の方を募集中");
			t56 = space();
			p3 = element("p");
			t57 = text("20代・30代はもちろんの事、40代・50代それ以上の中高年の方、ミドル・シニア世代の方も大歓迎! 一度整備士を離れてしまったというブランクがある方もOKです。");
		},
		l(nodes) {
			tr0 = claim_element(nodes, "TR", {});
			var tr0_nodes = children(tr0);
			th0 = claim_element(tr0_nodes, "TH", {});
			var th0_nodes = children(th0);
			t0 = claim_text(th0_nodes, "募集職種");
			th0_nodes.forEach(detach);
			t1 = claim_space(tr0_nodes);
			td0 = claim_element(tr0_nodes, "TD", {});
			var td0_nodes = children(td0);
			t2 = claim_text(td0_nodes, "自動車整備士");
			td0_nodes.forEach(detach);
			tr0_nodes.forEach(detach);
			t3 = claim_space(nodes);
			tr1 = claim_element(nodes, "TR", {});
			var tr1_nodes = children(tr1);
			th1 = claim_element(tr1_nodes, "TH", {});
			var th1_nodes = children(th1);
			t4 = claim_text(th1_nodes, "雇用形態");
			th1_nodes.forEach(detach);
			t5 = claim_space(tr1_nodes);
			td1 = claim_element(tr1_nodes, "TD", {});
			var td1_nodes = children(td1);
			t6 = claim_text(td1_nodes, "正社員");
			td1_nodes.forEach(detach);
			tr1_nodes.forEach(detach);
			t7 = claim_space(nodes);
			tr2 = claim_element(nodes, "TR", {});
			var tr2_nodes = children(tr2);
			th2 = claim_element(tr2_nodes, "TH", {});
			var th2_nodes = children(th2);
			t8 = claim_text(th2_nodes, "仕事内容");
			th2_nodes.forEach(detach);
			t9 = claim_space(tr2_nodes);
			td2 = claim_element(tr2_nodes, "TD", {});
			var td2_nodes = children(td2);
			p0 = claim_element(td2_nodes, "P", {});
			var p0_nodes = children(p0);
			t10 = claim_text(p0_nodes, "一般自動車から特装車まで幅広い車種の自動車整備、車検、定期点検業務");
			p0_nodes.forEach(detach);
			t11 = claim_space(td2_nodes);
			p1 = claim_element(td2_nodes, "P", {});
			var p1_nodes = children(p1);
			t12 = claim_text(p1_nodes, "エンジンオイル、オートマチックオイル、冷却水、タイヤ交換などの整備をはじめ、お客様のお車の使用頻度や状況に合わ せた部品交換や修理などのメンテナンス含め、幅広くサポートをお願いします。");
			p1_nodes.forEach(detach);
			td2_nodes.forEach(detach);
			tr2_nodes.forEach(detach);
			t13 = claim_space(nodes);
			tr3 = claim_element(nodes, "TR", {});
			var tr3_nodes = children(tr3);
			th3 = claim_element(tr3_nodes, "TH", {});
			var th3_nodes = children(th3);
			t14 = claim_text(th3_nodes, "勤務地");
			th3_nodes.forEach(detach);
			t15 = claim_space(tr3_nodes);
			td3 = claim_element(tr3_nodes, "TD", {});
			var td3_nodes = children(td3);
			t16 = claim_text(td3_nodes, "本社工場／群馬県前橋市三俣町2-1-3");
			br0 = claim_element(td3_nodes, "BR", {});
			t17 = claim_text(td3_nodes, "\n              芳賀特装工場／群馬県前橋市鳥取町646-3");
			td3_nodes.forEach(detach);
			tr3_nodes.forEach(detach);
			t18 = claim_space(nodes);
			tr4 = claim_element(nodes, "TR", {});
			var tr4_nodes = children(tr4);
			th4 = claim_element(tr4_nodes, "TH", {});
			var th4_nodes = children(th4);
			t19 = claim_text(th4_nodes, "勤務時間");
			th4_nodes.forEach(detach);
			t20 = claim_space(tr4_nodes);
			td4 = claim_element(tr4_nodes, "TD", {});
			var td4_nodes = children(td4);
			t21 = claim_text(td4_nodes, "8:30~17:30（休憩60分） ※時間外有り、月平均15時間程度");
			td4_nodes.forEach(detach);
			tr4_nodes.forEach(detach);
			t22 = claim_space(nodes);
			tr5 = claim_element(nodes, "TR", {});
			var tr5_nodes = children(tr5);
			th5 = claim_element(tr5_nodes, "TH", {});
			var th5_nodes = children(th5);
			t23 = claim_text(th5_nodes, "休日・休暇");
			th5_nodes.forEach(detach);
			t24 = claim_space(tr5_nodes);
			td5 = claim_element(tr5_nodes, "TD", {});
			var td5_nodes = children(td5);
			t25 = claim_text(td5_nodes, "土曜、日曜、祝日、夏季、年末年始");
			br1 = claim_element(td5_nodes, "BR", {});
			t26 = claim_text(td5_nodes, "※土曜出勤応相談 有給休暇、結婚休暇、産休・育休制度有り");
			td5_nodes.forEach(detach);
			tr5_nodes.forEach(detach);
			t27 = claim_space(nodes);
			tr6 = claim_element(nodes, "TR", {});
			var tr6_nodes = children(tr6);
			th6 = claim_element(tr6_nodes, "TH", {});
			var th6_nodes = children(th6);
			t28 = claim_text(th6_nodes, "給与");
			th6_nodes.forEach(detach);
			t29 = claim_space(tr6_nodes);
			td6 = claim_element(tr6_nodes, "TD", {});
			var td6_nodes = children(td6);
			t30 = claim_text(td6_nodes, "月給180,000~350,000円");
			br2 = claim_element(td6_nodes, "BR", {});
			t31 = claim_text(td6_nodes, "※経験・スキルにより決定します");
			td6_nodes.forEach(detach);
			tr6_nodes.forEach(detach);
			t32 = claim_space(nodes);
			tr7 = claim_element(nodes, "TR", {});
			var tr7_nodes = children(tr7);
			th7 = claim_element(tr7_nodes, "TH", {});
			var th7_nodes = children(th7);
			t33 = claim_text(th7_nodes, "諸手当");
			th7_nodes.forEach(detach);
			t34 = claim_space(tr7_nodes);
			td7 = claim_element(tr7_nodes, "TD", {});
			var td7_nodes = children(td7);
			t35 = claim_text(td7_nodes, "残業手当、休日出勤手当、資格手当、役職手当");
			td7_nodes.forEach(detach);
			tr7_nodes.forEach(detach);
			t36 = claim_space(nodes);
			tr8 = claim_element(nodes, "TR", {});
			var tr8_nodes = children(tr8);
			th8 = claim_element(tr8_nodes, "TH", {});
			var th8_nodes = children(th8);
			t37 = claim_text(th8_nodes, "昇給");
			th8_nodes.forEach(detach);
			t38 = claim_space(tr8_nodes);
			td8 = claim_element(tr8_nodes, "TD", {});
			var td8_nodes = children(td8);
			t39 = claim_text(td8_nodes, "年1回（4月）※業績に応じて");
			td8_nodes.forEach(detach);
			tr8_nodes.forEach(detach);
			t40 = claim_space(nodes);
			tr9 = claim_element(nodes, "TR", {});
			var tr9_nodes = children(tr9);
			th9 = claim_element(tr9_nodes, "TH", {});
			var th9_nodes = children(th9);
			t41 = claim_text(th9_nodes, "賞与");
			th9_nodes.forEach(detach);
			t42 = claim_space(tr9_nodes);
			td9 = claim_element(tr9_nodes, "TD", {});
			var td9_nodes = children(td9);
			t43 = claim_text(td9_nodes, "年2回（業績に応じて支給）");
			td9_nodes.forEach(detach);
			tr9_nodes.forEach(detach);
			t44 = claim_space(nodes);
			tr10 = claim_element(nodes, "TR", {});
			var tr10_nodes = children(tr10);
			th10 = claim_element(tr10_nodes, "TH", {});
			var th10_nodes = children(th10);
			t45 = claim_text(th10_nodes, "福利厚生");
			th10_nodes.forEach(detach);
			t46 = claim_space(tr10_nodes);
			td10 = claim_element(tr10_nodes, "TD", {});
			var td10_nodes = children(td10);
			t47 = claim_text(td10_nodes, "社会保険完備（健康保険・厚生年金保険・雇用保険・労災保険）、健康診断、マイカー・バイク・自転車通勤可、制服貸与、資格取得支援制度（規定有り）、再雇用制度、食事スペース・休憩スペース有り");
			td10_nodes.forEach(detach);
			tr10_nodes.forEach(detach);
			t48 = claim_space(nodes);
			tr11 = claim_element(nodes, "TR", {});
			var tr11_nodes = children(tr11);
			th11 = claim_element(tr11_nodes, "TH", {});
			var th11_nodes = children(th11);
			t49 = claim_text(th11_nodes, "資格・経験");
			th11_nodes.forEach(detach);
			t50 = claim_space(tr11_nodes);
			td11 = claim_element(tr11_nodes, "TD", {});
			var td11_nodes = children(td11);
			t51 = claim_text(td11_nodes, "自動車整備士＜経験者優遇＞普通自動車免許（AT限定不可）");
			td11_nodes.forEach(detach);
			tr11_nodes.forEach(detach);
			t52 = claim_space(nodes);
			tr12 = claim_element(nodes, "TR", {});
			var tr12_nodes = children(tr12);
			th12 = claim_element(tr12_nodes, "TH", {});
			var th12_nodes = children(th12);
			t53 = claim_text(th12_nodes, "学歴・年齢");
			th12_nodes.forEach(detach);
			t54 = claim_space(tr12_nodes);
			td12 = claim_element(tr12_nodes, "TD", {});
			var td12_nodes = children(td12);
			p2 = claim_element(td12_nodes, "P", {});
			var p2_nodes = children(p2);
			t55 = claim_text(p2_nodes, "高卒以上、男女問わず幅広い年齢の方を募集中");
			p2_nodes.forEach(detach);
			t56 = claim_space(td12_nodes);
			p3 = claim_element(td12_nodes, "P", {});
			var p3_nodes = children(p3);
			t57 = claim_text(p3_nodes, "20代・30代はもちろんの事、40代・50代それ以上の中高年の方、ミドル・シニア世代の方も大歓迎! 一度整備士を離れてしまったというブランクがある方もOKです。");
			p3_nodes.forEach(detach);
			td12_nodes.forEach(detach);
			tr12_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, tr0, anchor);
			append(tr0, th0);
			append(th0, t0);
			append(tr0, t1);
			append(tr0, td0);
			append(td0, t2);
			insert(target, t3, anchor);
			insert(target, tr1, anchor);
			append(tr1, th1);
			append(th1, t4);
			append(tr1, t5);
			append(tr1, td1);
			append(td1, t6);
			insert(target, t7, anchor);
			insert(target, tr2, anchor);
			append(tr2, th2);
			append(th2, t8);
			append(tr2, t9);
			append(tr2, td2);
			append(td2, p0);
			append(p0, t10);
			append(td2, t11);
			append(td2, p1);
			append(p1, t12);
			insert(target, t13, anchor);
			insert(target, tr3, anchor);
			append(tr3, th3);
			append(th3, t14);
			append(tr3, t15);
			append(tr3, td3);
			append(td3, t16);
			append(td3, br0);
			append(td3, t17);
			insert(target, t18, anchor);
			insert(target, tr4, anchor);
			append(tr4, th4);
			append(th4, t19);
			append(tr4, t20);
			append(tr4, td4);
			append(td4, t21);
			insert(target, t22, anchor);
			insert(target, tr5, anchor);
			append(tr5, th5);
			append(th5, t23);
			append(tr5, t24);
			append(tr5, td5);
			append(td5, t25);
			append(td5, br1);
			append(td5, t26);
			insert(target, t27, anchor);
			insert(target, tr6, anchor);
			append(tr6, th6);
			append(th6, t28);
			append(tr6, t29);
			append(tr6, td6);
			append(td6, t30);
			append(td6, br2);
			append(td6, t31);
			insert(target, t32, anchor);
			insert(target, tr7, anchor);
			append(tr7, th7);
			append(th7, t33);
			append(tr7, t34);
			append(tr7, td7);
			append(td7, t35);
			insert(target, t36, anchor);
			insert(target, tr8, anchor);
			append(tr8, th8);
			append(th8, t37);
			append(tr8, t38);
			append(tr8, td8);
			append(td8, t39);
			insert(target, t40, anchor);
			insert(target, tr9, anchor);
			append(tr9, th9);
			append(th9, t41);
			append(tr9, t42);
			append(tr9, td9);
			append(td9, t43);
			insert(target, t44, anchor);
			insert(target, tr10, anchor);
			append(tr10, th10);
			append(th10, t45);
			append(tr10, t46);
			append(tr10, td10);
			append(td10, t47);
			insert(target, t48, anchor);
			insert(target, tr11, anchor);
			append(tr11, th11);
			append(th11, t49);
			append(tr11, t50);
			append(tr11, td11);
			append(td11, t51);
			insert(target, t52, anchor);
			insert(target, tr12, anchor);
			append(tr12, th12);
			append(th12, t53);
			append(tr12, t54);
			append(tr12, td12);
			append(td12, p2);
			append(p2, t55);
			append(td12, t56);
			append(td12, p3);
			append(p3, t57);
		},
		d(detaching) {
			if (detaching) detach(tr0);
			if (detaching) detach(t3);
			if (detaching) detach(tr1);
			if (detaching) detach(t7);
			if (detaching) detach(tr2);
			if (detaching) detach(t13);
			if (detaching) detach(tr3);
			if (detaching) detach(t18);
			if (detaching) detach(tr4);
			if (detaching) detach(t22);
			if (detaching) detach(tr5);
			if (detaching) detach(t27);
			if (detaching) detach(tr6);
			if (detaching) detach(t32);
			if (detaching) detach(tr7);
			if (detaching) detach(t36);
			if (detaching) detach(tr8);
			if (detaching) detach(t40);
			if (detaching) detach(tr9);
			if (detaching) detach(t44);
			if (detaching) detach(tr10);
			if (detaching) detach(t48);
			if (detaching) detach(tr11);
			if (detaching) detach(t52);
			if (detaching) detach(tr12);
		}
	};
}

// (275:6) <Item>
function create_default_slot_13(ctx) {
	let table;
	let current;

	table = new Table({
			props: {
				$$slots: { default: [create_default_slot_14] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(table.$$.fragment);
		},
		l(nodes) {
			claim_component(table.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(table, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const table_changes = {};

			if (dirty & /*$$scope*/ 2) {
				table_changes.$$scope = { dirty, ctx };
			}

			table.$set(table_changes);
		},
		i(local) {
			if (current) return;
			transition_in(table.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(table.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(table, detaching);
		}
	};
}

// (268:4) <Inner>
function create_default_slot_12(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "募集要項",
				image: "/images/recruit.png",
				color: "orange"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_13] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (267:2) <Wrap>
function create_default_slot_11(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_12] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (266:0) <Section kind="top-small">
function create_default_slot_10(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_11] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (347:6) <Item align="center">
function create_default_slot_9(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				name: "応募される方のお問い合わせフォームはこちら",
				href: "/contact?kind=recruit"
			}
		});

	return {
		c() {
			create_component(button.$$.fragment);
		},
		l(nodes) {
			claim_component(button.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (346:4) <Inner>
function create_default_slot_8(ctx) {
	let item;
	let current;

	item = new Item({
			props: {
				align: "center",
				$$slots: { default: [create_default_slot_9] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(item, detaching);
		}
	};
}

// (345:2) <Wrap>
function create_default_slot_7(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_8] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (344:0) <Section kind="small">
function create_default_slot_6(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_7] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

// (355:2) <Inner>
function create_default_slot_5(ctx) {
	let hr;
	let current;
	hr = new Hr({});

	return {
		c() {
			create_component(hr.$$.fragment);
		},
		l(nodes) {
			claim_component(hr.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(hr, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(hr.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(hr.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(hr, detaching);
		}
	};
}

// (354:0) <Wrap>
function create_default_slot_4(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_5] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (369:6) <Item>
function create_default_slot_3(ctx) {
	let p;
	let t0;
	let br0;
	let t1;
	let br1;
	let t2;

	return {
		c() {
			p = element("p");
			t0 = text("群馬県前橋市三俣町2丁目1-3");
			br0 = element("br");
			t1 = text("\n          TEL.027-231-9008");
			br1 = element("br");
			t2 = text("\n          採用担当／倉賀野");
		},
		l(nodes) {
			p = claim_element(nodes, "P", {});
			var p_nodes = children(p);
			t0 = claim_text(p_nodes, "群馬県前橋市三俣町2丁目1-3");
			br0 = claim_element(p_nodes, "BR", {});
			t1 = claim_text(p_nodes, "\n          TEL.027-231-9008");
			br1 = claim_element(p_nodes, "BR", {});
			t2 = claim_text(p_nodes, "\n          採用担当／倉賀野");
			p_nodes.forEach(detach);
		},
		m(target, anchor) {
			insert(target, p, anchor);
			append(p, t0);
			append(p, br0);
			append(p, t1);
			append(p, br1);
			append(p, t2);
		},
		d(detaching) {
			if (detaching) detach(p);
		}
	};
}

// (362:4) <Inner>
function create_default_slot_2(ctx) {
	let heading;
	let t;
	let item;
	let current;

	heading = new Heading({
			props: {
				name: "連絡先",
				image: "/images/recruit.png",
				color: "orange"
			}
		});

	item = new Item({
			props: {
				$$slots: { default: [create_default_slot_3] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(heading.$$.fragment);
			t = space();
			create_component(item.$$.fragment);
		},
		l(nodes) {
			claim_component(heading.$$.fragment, nodes);
			t = claim_space(nodes);
			claim_component(item.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(heading, target, anchor);
			insert(target, t, anchor);
			mount_component(item, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const item_changes = {};

			if (dirty & /*$$scope*/ 2) {
				item_changes.$$scope = { dirty, ctx };
			}

			item.$set(item_changes);
		},
		i(local) {
			if (current) return;
			transition_in(heading.$$.fragment, local);
			transition_in(item.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(heading.$$.fragment, local);
			transition_out(item.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(heading, detaching);
			if (detaching) detach(t);
			destroy_component(item, detaching);
		}
	};
}

// (361:2) <Wrap>
function create_default_slot_1(ctx) {
	let inner;
	let current;

	inner = new Inner({
			props: {
				$$slots: { default: [create_default_slot_2] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(inner.$$.fragment);
		},
		l(nodes) {
			claim_component(inner.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(inner, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const inner_changes = {};

			if (dirty & /*$$scope*/ 2) {
				inner_changes.$$scope = { dirty, ctx };
			}

			inner.$set(inner_changes);
		},
		i(local) {
			if (current) return;
			transition_in(inner.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(inner.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(inner, detaching);
		}
	};
}

// (360:0) <Section kind="small">
function create_default_slot(ctx) {
	let wrap;
	let current;

	wrap = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(wrap.$$.fragment);
		},
		l(nodes) {
			claim_component(wrap.$$.fragment, nodes);
		},
		m(target, anchor) {
			mount_component(wrap, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const wrap_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap_changes.$$scope = { dirty, ctx };
			}

			wrap.$set(wrap_changes);
		},
		i(local) {
			if (current) return;
			transition_in(wrap.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(wrap.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(wrap, detaching);
		}
	};
}

function create_fragment(ctx) {
	let meta0;
	let meta1;
	let meta2;
	let meta3;
	let meta4;
	let t0;
	let nav;
	let t1;
	let section0;
	let t2;
	let section1;
	let t3;
	let section2;
	let t4;
	let section3;
	let t5;
	let wrap0;
	let t6;
	let section4;
	let t7;
	let wrap1;
	let t8;
	let section5;
	let t9;
	let wrap2;
	let t10;
	let section6;
	let t11;
	let wrap3;
	let t12;
	let section7;
	let t13;
	let wrap4;
	let t14;
	let section8;
	let t15;
	let section9;
	let t16;
	let section10;
	let t17;
	let wrap5;
	let t18;
	let section11;
	let t19;
	let section12;
	let t20;
	let wrap6;
	let t21;
	let section13;
	let current;
	nav = new Nav({ props: { segment: "recruit" } });

	section0 = new Section({
			props: {
				kind: "gapless",
				$$slots: { default: [create_default_slot_72] },
				$$scope: { ctx }
			}
		});

	section1 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_70] },
				$$scope: { ctx }
			}
		});

	section2 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_67] },
				$$scope: { ctx }
			}
		});

	section3 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_63] },
				$$scope: { ctx }
			}
		});

	wrap0 = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_61] },
				$$scope: { ctx }
			}
		});

	section4 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_56] },
				$$scope: { ctx }
			}
		});

	wrap1 = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_54] },
				$$scope: { ctx }
			}
		});

	section5 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_49] },
				$$scope: { ctx }
			}
		});

	wrap2 = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_47] },
				$$scope: { ctx }
			}
		});

	section6 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_39] },
				$$scope: { ctx }
			}
		});

	wrap3 = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_37] },
				$$scope: { ctx }
			}
		});

	section7 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_30] },
				$$scope: { ctx }
			}
		});

	wrap4 = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_28] },
				$$scope: { ctx }
			}
		});

	section8 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_24] },
				$$scope: { ctx }
			}
		});

	section9 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_20] },
				$$scope: { ctx }
			}
		});

	section10 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_17] },
				$$scope: { ctx }
			}
		});

	wrap5 = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_15] },
				$$scope: { ctx }
			}
		});

	section11 = new Section({
			props: {
				kind: "top-small",
				$$slots: { default: [create_default_slot_10] },
				$$scope: { ctx }
			}
		});

	section12 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot_6] },
				$$scope: { ctx }
			}
		});

	wrap6 = new Wrap({
			props: {
				$$slots: { default: [create_default_slot_4] },
				$$scope: { ctx }
			}
		});

	section13 = new Section({
			props: {
				kind: "small",
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			meta0 = element("meta");
			meta1 = element("meta");
			meta2 = element("meta");
			meta3 = element("meta");
			meta4 = element("meta");
			t0 = space();
			create_component(nav.$$.fragment);
			t1 = space();
			create_component(section0.$$.fragment);
			t2 = space();
			create_component(section1.$$.fragment);
			t3 = space();
			create_component(section2.$$.fragment);
			t4 = space();
			create_component(section3.$$.fragment);
			t5 = space();
			create_component(wrap0.$$.fragment);
			t6 = space();
			create_component(section4.$$.fragment);
			t7 = space();
			create_component(wrap1.$$.fragment);
			t8 = space();
			create_component(section5.$$.fragment);
			t9 = space();
			create_component(wrap2.$$.fragment);
			t10 = space();
			create_component(section6.$$.fragment);
			t11 = space();
			create_component(wrap3.$$.fragment);
			t12 = space();
			create_component(section7.$$.fragment);
			t13 = space();
			create_component(wrap4.$$.fragment);
			t14 = space();
			create_component(section8.$$.fragment);
			t15 = space();
			create_component(section9.$$.fragment);
			t16 = space();
			create_component(section10.$$.fragment);
			t17 = space();
			create_component(wrap5.$$.fragment);
			t18 = space();
			create_component(section11.$$.fragment);
			t19 = space();
			create_component(section12.$$.fragment);
			t20 = space();
			create_component(wrap6.$$.fragment);
			t21 = space();
			create_component(section13.$$.fragment);
			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-15tq84e\"]", document.head);
			meta0 = claim_element(head_nodes, "META", { name: true, content: true });
			meta1 = claim_element(head_nodes, "META", { property: true, content: true });
			meta2 = claim_element(head_nodes, "META", { property: true, content: true });
			meta3 = claim_element(head_nodes, "META", { property: true, content: true });
			meta4 = claim_element(head_nodes, "META", { property: true, content: true });
			head_nodes.forEach(detach);
			t0 = claim_space(nodes);
			claim_component(nav.$$.fragment, nodes);
			t1 = claim_space(nodes);
			claim_component(section0.$$.fragment, nodes);
			t2 = claim_space(nodes);
			claim_component(section1.$$.fragment, nodes);
			t3 = claim_space(nodes);
			claim_component(section2.$$.fragment, nodes);
			t4 = claim_space(nodes);
			claim_component(section3.$$.fragment, nodes);
			t5 = claim_space(nodes);
			claim_component(wrap0.$$.fragment, nodes);
			t6 = claim_space(nodes);
			claim_component(section4.$$.fragment, nodes);
			t7 = claim_space(nodes);
			claim_component(wrap1.$$.fragment, nodes);
			t8 = claim_space(nodes);
			claim_component(section5.$$.fragment, nodes);
			t9 = claim_space(nodes);
			claim_component(wrap2.$$.fragment, nodes);
			t10 = claim_space(nodes);
			claim_component(section6.$$.fragment, nodes);
			t11 = claim_space(nodes);
			claim_component(wrap3.$$.fragment, nodes);
			t12 = claim_space(nodes);
			claim_component(section7.$$.fragment, nodes);
			t13 = claim_space(nodes);
			claim_component(wrap4.$$.fragment, nodes);
			t14 = claim_space(nodes);
			claim_component(section8.$$.fragment, nodes);
			t15 = claim_space(nodes);
			claim_component(section9.$$.fragment, nodes);
			t16 = claim_space(nodes);
			claim_component(section10.$$.fragment, nodes);
			t17 = claim_space(nodes);
			claim_component(wrap5.$$.fragment, nodes);
			t18 = claim_space(nodes);
			claim_component(section11.$$.fragment, nodes);
			t19 = claim_space(nodes);
			claim_component(section12.$$.fragment, nodes);
			t20 = claim_space(nodes);
			claim_component(wrap6.$$.fragment, nodes);
			t21 = claim_space(nodes);
			claim_component(section13.$$.fragment, nodes);
			this.h();
		},
		h() {
			document.title = "採用情報 | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車";
			attr(meta0, "name", "description");
			attr(meta0, "content", "協和自動車有限会社の採用情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta1, "property", "og:url");
			attr(meta1, "content", "https://kyouwaji.com/recruit/");
			attr(meta2, "property", "og:title");
			attr(meta2, "content", "採用情報 | 協和自動車有限会社 | 群馬県前橋市で自動車車検・修理なら協和自動車");
			attr(meta3, "property", "og:description");
			attr(meta3, "content", "協和自動車有限会社の採用情報です。私たち協和自動車は1964年に創業した会社です。以来、モータリゼーションの波をとらえ、群馬県が全国トップクラスの自動車王国になる一端を担ってまいりました。その間、高所作業車で国内トップシェアを持つアイチコポーレーションのサービス工場に指定。今日では、軽自動車から普通自動車、さ らには大型・特殊車両まで、幅広くサービスを提供する自動車整備会社へと成長しています。");
			attr(meta4, "property", "og:type");
			attr(meta4, "content", "article");
		},
		m(target, anchor) {
			append(document.head, meta0);
			append(document.head, meta1);
			append(document.head, meta2);
			append(document.head, meta3);
			append(document.head, meta4);
			insert(target, t0, anchor);
			mount_component(nav, target, anchor);
			insert(target, t1, anchor);
			mount_component(section0, target, anchor);
			insert(target, t2, anchor);
			mount_component(section1, target, anchor);
			insert(target, t3, anchor);
			mount_component(section2, target, anchor);
			insert(target, t4, anchor);
			mount_component(section3, target, anchor);
			insert(target, t5, anchor);
			mount_component(wrap0, target, anchor);
			insert(target, t6, anchor);
			mount_component(section4, target, anchor);
			insert(target, t7, anchor);
			mount_component(wrap1, target, anchor);
			insert(target, t8, anchor);
			mount_component(section5, target, anchor);
			insert(target, t9, anchor);
			mount_component(wrap2, target, anchor);
			insert(target, t10, anchor);
			mount_component(section6, target, anchor);
			insert(target, t11, anchor);
			mount_component(wrap3, target, anchor);
			insert(target, t12, anchor);
			mount_component(section7, target, anchor);
			insert(target, t13, anchor);
			mount_component(wrap4, target, anchor);
			insert(target, t14, anchor);
			mount_component(section8, target, anchor);
			insert(target, t15, anchor);
			mount_component(section9, target, anchor);
			insert(target, t16, anchor);
			mount_component(section10, target, anchor);
			insert(target, t17, anchor);
			mount_component(wrap5, target, anchor);
			insert(target, t18, anchor);
			mount_component(section11, target, anchor);
			insert(target, t19, anchor);
			mount_component(section12, target, anchor);
			insert(target, t20, anchor);
			mount_component(wrap6, target, anchor);
			insert(target, t21, anchor);
			mount_component(section13, target, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			const section0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section0_changes.$$scope = { dirty, ctx };
			}

			section0.$set(section0_changes);
			const section1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section1_changes.$$scope = { dirty, ctx };
			}

			section1.$set(section1_changes);
			const section2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section2_changes.$$scope = { dirty, ctx };
			}

			section2.$set(section2_changes);
			const section3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section3_changes.$$scope = { dirty, ctx };
			}

			section3.$set(section3_changes);
			const wrap0_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap0_changes.$$scope = { dirty, ctx };
			}

			wrap0.$set(wrap0_changes);
			const section4_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section4_changes.$$scope = { dirty, ctx };
			}

			section4.$set(section4_changes);
			const wrap1_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap1_changes.$$scope = { dirty, ctx };
			}

			wrap1.$set(wrap1_changes);
			const section5_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section5_changes.$$scope = { dirty, ctx };
			}

			section5.$set(section5_changes);
			const wrap2_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap2_changes.$$scope = { dirty, ctx };
			}

			wrap2.$set(wrap2_changes);
			const section6_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section6_changes.$$scope = { dirty, ctx };
			}

			section6.$set(section6_changes);
			const wrap3_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap3_changes.$$scope = { dirty, ctx };
			}

			wrap3.$set(wrap3_changes);
			const section7_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section7_changes.$$scope = { dirty, ctx };
			}

			section7.$set(section7_changes);
			const wrap4_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap4_changes.$$scope = { dirty, ctx };
			}

			wrap4.$set(wrap4_changes);
			const section8_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section8_changes.$$scope = { dirty, ctx };
			}

			section8.$set(section8_changes);
			const section9_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section9_changes.$$scope = { dirty, ctx };
			}

			section9.$set(section9_changes);
			const section10_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section10_changes.$$scope = { dirty, ctx };
			}

			section10.$set(section10_changes);
			const wrap5_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap5_changes.$$scope = { dirty, ctx };
			}

			wrap5.$set(wrap5_changes);
			const section11_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section11_changes.$$scope = { dirty, ctx };
			}

			section11.$set(section11_changes);
			const section12_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section12_changes.$$scope = { dirty, ctx };
			}

			section12.$set(section12_changes);
			const wrap6_changes = {};

			if (dirty & /*$$scope*/ 2) {
				wrap6_changes.$$scope = { dirty, ctx };
			}

			wrap6.$set(wrap6_changes);
			const section13_changes = {};

			if (dirty & /*$$scope*/ 2) {
				section13_changes.$$scope = { dirty, ctx };
			}

			section13.$set(section13_changes);
		},
		i(local) {
			if (current) return;
			transition_in(nav.$$.fragment, local);
			transition_in(section0.$$.fragment, local);
			transition_in(section1.$$.fragment, local);
			transition_in(section2.$$.fragment, local);
			transition_in(section3.$$.fragment, local);
			transition_in(wrap0.$$.fragment, local);
			transition_in(section4.$$.fragment, local);
			transition_in(wrap1.$$.fragment, local);
			transition_in(section5.$$.fragment, local);
			transition_in(wrap2.$$.fragment, local);
			transition_in(section6.$$.fragment, local);
			transition_in(wrap3.$$.fragment, local);
			transition_in(section7.$$.fragment, local);
			transition_in(wrap4.$$.fragment, local);
			transition_in(section8.$$.fragment, local);
			transition_in(section9.$$.fragment, local);
			transition_in(section10.$$.fragment, local);
			transition_in(wrap5.$$.fragment, local);
			transition_in(section11.$$.fragment, local);
			transition_in(section12.$$.fragment, local);
			transition_in(wrap6.$$.fragment, local);
			transition_in(section13.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(nav.$$.fragment, local);
			transition_out(section0.$$.fragment, local);
			transition_out(section1.$$.fragment, local);
			transition_out(section2.$$.fragment, local);
			transition_out(section3.$$.fragment, local);
			transition_out(wrap0.$$.fragment, local);
			transition_out(section4.$$.fragment, local);
			transition_out(wrap1.$$.fragment, local);
			transition_out(section5.$$.fragment, local);
			transition_out(wrap2.$$.fragment, local);
			transition_out(section6.$$.fragment, local);
			transition_out(wrap3.$$.fragment, local);
			transition_out(section7.$$.fragment, local);
			transition_out(wrap4.$$.fragment, local);
			transition_out(section8.$$.fragment, local);
			transition_out(section9.$$.fragment, local);
			transition_out(section10.$$.fragment, local);
			transition_out(wrap5.$$.fragment, local);
			transition_out(section11.$$.fragment, local);
			transition_out(section12.$$.fragment, local);
			transition_out(wrap6.$$.fragment, local);
			transition_out(section13.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			detach(meta0);
			detach(meta1);
			detach(meta2);
			detach(meta3);
			detach(meta4);
			if (detaching) detach(t0);
			destroy_component(nav, detaching);
			if (detaching) detach(t1);
			destroy_component(section0, detaching);
			if (detaching) detach(t2);
			destroy_component(section1, detaching);
			if (detaching) detach(t3);
			destroy_component(section2, detaching);
			if (detaching) detach(t4);
			destroy_component(section3, detaching);
			if (detaching) detach(t5);
			destroy_component(wrap0, detaching);
			if (detaching) detach(t6);
			destroy_component(section4, detaching);
			if (detaching) detach(t7);
			destroy_component(wrap1, detaching);
			if (detaching) detach(t8);
			destroy_component(section5, detaching);
			if (detaching) detach(t9);
			destroy_component(wrap2, detaching);
			if (detaching) detach(t10);
			destroy_component(section6, detaching);
			if (detaching) detach(t11);
			destroy_component(wrap3, detaching);
			if (detaching) detach(t12);
			destroy_component(section7, detaching);
			if (detaching) detach(t13);
			destroy_component(wrap4, detaching);
			if (detaching) detach(t14);
			destroy_component(section8, detaching);
			if (detaching) detach(t15);
			destroy_component(section9, detaching);
			if (detaching) detach(t16);
			destroy_component(section10, detaching);
			if (detaching) detach(t17);
			destroy_component(wrap5, detaching);
			if (detaching) detach(t18);
			destroy_component(section11, detaching);
			if (detaching) detach(t19);
			destroy_component(section12, detaching);
			if (detaching) detach(t20);
			destroy_component(wrap6, detaching);
			if (detaching) detach(t21);
			destroy_component(section13, detaching);
		}
	};
}

function instance($$self) {
	const paths = [{ name: "HOME", href: "/" }, { name: "採用情報" }];
	return [paths];
}

class Recruit extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default Recruit;
//# sourceMappingURL=recruit.svelte.js.map
